import {Button} from "react-bootstrap";
import {useState} from "react";


function RoverRoutePlanning( {onReturnClicked, onResetClicked, onRefreshClicked, onExportKmlClicked, onExportJsonClicked} ) {

    const [corridorWidth, setCorridorWidth] = useState(42);
    const [curveRadius, setCurveRadius] = useState(9);


    return(
        <div>
            <form>
                <div className={"row"}>
                    <div className={"col"}>Corridor:</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={corridorWidth} step={1} onChange={event => { setCorridorWidth(parseInt(event.target.value)) }}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>Curve:</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={curveRadius} step={0.5} onChange={event => { setCurveRadius(parseInt(event.target.value)) }}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-2"}>
                        <Button onClick={onReturnClicked}>Back</Button><br/>
                        <Button onClick={event => onResetClicked(corridorWidth, curveRadius)}>Reset</Button><br/>
                        {/*<Button onClick={event => onRefreshClicked(corridorWidth, curveRadius)}>Update&nbsp;Parameters</Button><br/>*/}
                        <Button onClick={event => onExportKmlClicked()}>Export&nbsp;Map.kml</Button>
                        <Button onClick={event => onExportJsonClicked()}>Export&nbsp;Work_Zones.json</Button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default RoverRoutePlanning;